module.exports = __webpack_public_path__ + "static/media/quiz-hint-3-en-1080p.befbd867.mp4";